<app-select-nft-collection
    [selectedNftCollections]="selectedNftCollections"
    [onlyFullDataCollection]="onlyFullDataCollection"
    [myCollections]="myCollections"
    [chain]="chain"
    [needDisableNoCommunityMyCollection]="needDisableNoCommunityMyCollection"
    (cancel)="modalRef.triggerCancel()"
    (confirm)="confirm($event)"
></app-select-nft-collection>
